import { Divider } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import clsx from 'clsx';
import PropTypes from 'prop-types';

import { Topbar } from './components';

const useStyles = makeStyles(() => ({
  root: {},
  content: {
    height: '100%',
  },
}));

const MinimalLayout = ({ themeMode, children, className }) => {
  const classes = useStyles();

  return (
    <div className={clsx(classes.root, className)}>
      <Topbar themeMode={themeMode} />
      <Divider />
      <main className={classes.content}>{children}</main>
    </div>
  );
};

MinimalLayout.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  themeMode: PropTypes.string.isRequired,
};

export default MinimalLayout;
